import { Routes } from '@/router/routes'

export const WALLET = `${Routes.VAULT}`

export const WALLET_SEARCH_XP = `${Routes.VAULT}?xp=true`
